import { render, staticRenderFns } from "./TasksSettings.vue?vue&type=template&id=cf452c38&"
import script from "./TasksSettings.vue?vue&type=script&lang=js&"
export * from "./TasksSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports